import { createContext, lazy, Suspense, useContext, useState } from 'react';

const PlateInspectionDialog = lazy(() => import('./PlateInspectionDialog.jsx'));
const PlateInspectionContext = createContext(null);

// Host the dialog outside the collapsible inspector so mobile layout changes
// and switching the source camera panel cannot hide an open inspection.
export function PlateInspectionProvider({ store, readOnly, children }) {
  const [request, setRequest] = useState(null);
  return <PlateInspectionContext.Provider value={setRequest}>{children}
    {request && <Suspense fallback={<p className="hint" role="status">Opening plate inspection…</p>}>
      <PlateInspectionDialog {...request} {...{ store, readOnly }} onClose={() => setRequest(null)} />
    </Suspense>}
  </PlateInspectionContext.Provider>;
}

/** Keep WebGL and detailed assets out of the ordinary 2D editor. */
export default function PlateInspectionButton({ cameraId, moduleId, plateKey, disabled = false }) {
  const request = useContext(PlateInspectionContext);
  return <button className="btn sm" disabled={disabled || !request} onClick={() => request({ cameraId, moduleId, plateKey })}>Inspect licence plates</button>;
}
